import type { ReactNode } from 'react';
import { Button, Card } from '@indipia/ui-core';
import { formatMonthDayDow, formatMonthDayDowTime, formatSharePhone, isValidPhone } from '@indipia/shared-features';
import { MSG, type DeliveryInfo } from '../../pages/share/vendorDelivery.logic';

// C-4-1 보낸 배송정보 요약(완료 화면·보기 모드 공통). 값은 서버 저장값 그대로 표시.

export interface SummaryPhoto {
  key: string;
  label: string;
  src: string;
}

interface Props {
  info: DeliveryInfo;
  photos: SummaryPhoto[];
  onOpenPhoto?: (index: number) => void;
}

function Row({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex gap-3">
      <dt className="w-20 shrink-0 text-body-sm font-semibold text-text-muted">{label}</dt>
      <dd className="min-w-0 flex-1 text-body-sm text-text-primary">{children}</dd>
    </div>
  );
}

export function DeliverySummary({ info, photos, onOpenPhoto }: Props) {
  return (
    <Card>
      <dl className="flex flex-col gap-2">
        <Row label={MSG.summaryArrival}>{formatMonthDayDowTime(info.arrivalDate, info.arrivalTime)}</Row>
        <Row label={MSG.summaryDriver}>
          {info.driverName} {info.driverPhone ? (isValidPhone(info.driverPhone) ? formatSharePhone(info.driverPhone) : info.driverPhone) : ''}
        </Row>
        <Row label={MSG.summaryPhotos}>
          {photos.length === 0 ? (
            MSG.summaryPhotosNone
          ) : (
            <>
              <span>{MSG.summaryPhotoCount(photos.length)}</span>
              <span className="mt-2 grid grid-cols-3 gap-2">
                {photos.map((p, i) => (
                  <Button
                    key={p.key}
                    variant="ghost"
                    aria-label={MSG.summaryPhotoOpen(p.label)}
                    disabled={!onOpenPhoto}
                    onClick={() => onOpenPhoto?.(i)}
                  >
                    <img src={p.src} alt={p.label} className="h-full w-full object-cover" />
                  </Button>
                ))}
              </span>
            </>
          )}
        </Row>
        {info.issueYn === 'Y' && <Row label={MSG.summaryIssue}>{info.issueNote}</Row>}
      </dl>
    </Card>
  );
}

/** 입고 희망일 등 날짜 한 줄 표기 보조(요청 카드용) */
export function dayText(ymd: string): string {
  return formatMonthDayDow(ymd);
}
